import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useClientSaveCitizenshipsMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { SaveCitizenshipParam } from 'api/types/params';

import { parseClientEntity } from '../helpers';

export const useClientSaveCitizenships = () => {
  const [handle, { data, loading, error: apolloError }] =
    useClientSaveCitizenshipsMutation();

  const error = useError(apolloError);

  return {
    data: data?.clientSaveCitizenships
      ? parseClientEntity(data.clientSaveCitizenships)
      : undefined,
    loading,
    error,
    saveCitizenships: useCallback(
      async (id: string, params: SaveCitizenshipParam) => {
        const res = await handle({
          variables: {
            id,
            input: params,
          },
        });
        return res?.data?.clientSaveCitizenships
          ? parseClientEntity(res.data.clientSaveCitizenships)
          : undefined;
      },
      [handle]
    ),
  };
};
